import Vue from 'vue';
import Axios from 'axios';
import router from './index.js';
import store from '../store/index';

router.afterEach( (to, from) => {

	// Only force focus to main content if we got there when content changes dynamically without a full page refresh.
	if( !!from.name ){
		const resetTab = document.getElementById('reset-tab');
		if (resetTab) {
			resetTab.focus();
		}
	}
	window.scrollTo(0, 0);
});

//Global Navigation Guards
router.beforeEach((to, from, next) => {
	if( to.query.hasOwnProperty('reset') ) {
		store.dispatch('reset');
	}

	if( !!store.getters.accessToken ){
		
		store.dispatch('fetchToken').then( response => {
			
			store.dispatch('initialize', to.query.student_rid).then(function(){
				/* force user to upgrade account */
				if(!!store.getters.credType && store.getters.credType === "LCLPWPIN"){
					if(from.name == 'UserConversionWizard'){
						alert('Please finish to account upgrade process.');
						return false;
					}
					else if(to.name !== 'UserConversionWizard'){
						return next( { name: "UserConversionWizard" } );
					}
				}
				else if(!!store.getters.forcePasswordChangeFlg && store.getters.forcePasswordChangeFlg === "Y"){
					/* force user to change their password */
					if(from.name == 'ForcePasswordChange'){
						alert('Please change your password before continuing.');
						return false;
					}
					else if(to.name !== 'ForcePasswordChange'){
						return next( { name: "ForcePasswordChange" } );
					}
				}
				next();
			});
		}).catch( response => {
			// Do Nothing. Need this so the rejected promise doesn't default to .then();
		});
	} else {
		store.dispatch('initialize', to.query.student_rid).then(function(){
			
			/* force user to upgrade account */
			if(!!store.getters.credType && store.getters.credType === "LCLPWPIN"){
				if(from.name == 'UserConversionWizard'){
					alert('Please finish to account upgrade process.');
					return false;
				}
				else if(to.name !== 'UserConversionWizard'){
					return next( { name: "UserConversionWizard" } );
				}
			}
			else if(!!store.getters.forcePasswordChangeFlg && store.getters.forcePasswordChangeFlg === "Y"){
				/* force user to change their password */
				if(from.name == 'ForcePasswordChange'){
					alert('Please change your password before continuing.');
					return false;
				}
				else if(to.name !== 'ForcePasswordChange'){
					return next( { name: "ForcePasswordChange" } );
				}
			}
			next();
		});
	}
	store.dispatch('hideError');
});


